import { RouterModule, Routes } from '@angular/router';

import { AddressConfirmationPage } from './address-confirmation.page';
import { NgModule } from '@angular/core';

const routes: Routes = [
  {
    path: '',
    component: AddressConfirmationPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AddressConfirmationPageRoutingModule {}
